import { useEffect, useState } from 'react'
import * as PubSub from '~/pubSub'
import * as Connectivity from '.'

export function useIsOnline() {
  const [isOnline, setIsOnline] = useState(Connectivity.isOnline())

  useEffect(() => {
    const handler = () => setIsOnline(Connectivity.isOnline())

    PubSub.subscribe('came-online', handler)
    PubSub.subscribe('went-offline', handler)

    return () => {
      PubSub.unsubscribe('came-online', handler)
      PubSub.unsubscribe('went-offline', handler)
    }
  }, [])

  return isOnline
}
